/**
 * PreviewImage component
 */

// React
import React, { FC } from 'react';

// Libraries
import { Dialog, DialogActions, DialogContent } from '@mui/material';

// Common styles
import { ButtonUpdate } from 'styles';

// Interface
interface PreviewModalModalProps {
  open: boolean;
  image: string;
  handleClose: () => void;
}

// Component
const PreviewImageModal: FC<PreviewModalModalProps> = ({ open, image, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '50px 20px',
        }}
      >
        <img style={{ width: '140px', height: 'auto' }} src={image} alt="Image" />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <ButtonUpdate
          onClick={handleClose}
          variant="outlined"
          sx={{ color: '#6EC8E2', border: '1px solid #6EC8E2' }}
        >
          戻る
        </ButtonUpdate>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewImageModal;
